"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLayerSwitcher = void 0;
var MapLayerSwitcherOverlays_1 = require("./MapLayerSwitcherOverlays");
var MapLayerSwitcherBaseLayers_1 = require("./MapLayerSwitcherBaseLayers");
var MapLayerSwitcherBaseLayersSlider_1 = require("./MapLayerSwitcherBaseLayersSlider");
var MapLayerSwitcher = /** @class */ (function () {
    function MapLayerSwitcher(_map, _mapStore, _styleFactory, _baseLayers, _layerGroups, _mappingTextPack, _config) {
        var _this = this;
        this._map = _map;
        this._mapStore = _mapStore;
        this._styleFactory = _styleFactory;
        this._baseLayers = _baseLayers;
        this._layerGroups = _layerGroups;
        this._mappingTextPack = _mappingTextPack;
        this._config = _config;
        this._initialised = false;
        this._overlaysInitialised = false;
        this._lastSlidePanelAction = "";
        this._scaleTooltipMessage = "Layer is not visible at this scale";
        this.init = function () {
            if (!_this._initialised) {
                _this.initConfig();
                if (_this._config.useBaseLayerSlider) {
                    _this._baseLayerSwitcher = new MapLayerSwitcherBaseLayersSlider_1.MapLayerSwitcherBaseLayersSlider(_this._map, _this._mapStore, _this._baseLayers, _this._mappingTextPack, _this._config);
                }
                else {
                    _this._baseLayerSwitcher = new MapLayerSwitcherBaseLayers_1.MapLayerSwitcherBaseLayers(_this._map, _this._mapStore, _this._baseLayers, _this._mappingTextPack);
                }
                _this.overlays = new MapLayerSwitcherOverlays_1.MapLayerSwitcherOverlays(_this._map, _this._mapStore, _this._layerGroups, _this._mappingTextPack);
                _this.addSlidingPanelsHandlers();
                _this.addHandlers();
                _this._initialised = true;
            }
        };
        this.initConfig = function () {
            var defaultConfig = {
                baseLayerSliderPosition: 0.5
            };
            if (_this._config !== null) {
                _this._config = __assign(__assign({}, defaultConfig), _this._config);
            }
            ;
        };
        this.addHandlers = function () {
            var self = _this;
            self.overlays.onOverlayChanged.subscribe(self._map.raiseOnLayerVisibilityChanged);
            self.overlays.onLayerAction.subscribe(self._map.raiseOnLayerAction);
            if (_this._config.useBaseLayerSlider) {
                self._baseLayerSwitcher.onSliderMoved.subscribe(function (args) {
                    self._mapStore.onBaseLayerSliderMoved(args.x);
                });
            }
        };
        this.addSlidingPanelsHandlers = function () {
            var self = _this;
            //must be a better way of retaining correct scope for 'this' and '$(this)' in the click handler??
            var lastSlidePanelAction_forScope = self._lastSlidePanelAction;
            if (_this._config.showList === false) {
                $("#slide-panel-btn-list").hide();
            }
            var onCloseSlidePanel = function () {
                var panel = $('#slide-panel');
                $('#slide-panel .content-panel').hide();
                panel.removeClass('visible').animate({
                    'margin-left': '-315px'
                });
                setTimeout(function () {
                    $('#slide-content').animate({
                        "width": 0,
                        "opacity": 0
                    });
                }, 350);
                lastSlidePanelAction_forScope = null;
                self._mapStore.onActivePanelChanged("none");
            };
            var onSlidePanelClick = function () {
                var panel = $('#slide-panel');
                var action = $(this).data("action");
                var activeContentPanelId = "#slide-panel-" + action;
                if (self._config.rememberActivePanel === true) {
                    self._mapStore.onActivePanelChanged(action);
                }
                //any action other than 'help'
                if (panel.hasClass("visible") && lastSlidePanelAction_forScope === action) {
                    onCloseSlidePanel();
                    $(this).blur();
                }
                else if (!panel.hasClass("visible")) {
                    //main panel closed     
                    $('#slide-content').css("width", "315px");
                    panel.addClass('visible').animate({
                        'margin-left': '0px'
                    });
                    $('#slide-content').animate({
                        "opacity": 1
                    });
                }
                if (panel.hasClass("visible")) {
                    //hide all the content panels and show the correct one
                    $('#slide-panel .content-panel').hide();
                    $(activeContentPanelId).show();
                    lastSlidePanelAction_forScope = action;
                    //we need to initialise the legend maps when the panel is first shown
                    if (action === "overlays") {
                        self.addOverlays();
                    }
                }
                return false;
            };
            $('.slide-panel-button').on('click', onSlidePanelClick);
            //handle close button on sliding panel
            $('#slide-panel .sidebar_heading .fa-times').on('click', function () {
                onCloseSlidePanel();
            });
            //set initial state for panel
            if (self._config.showOpenPanelByDefault) {
                var activePanel = self._mapStore.getMapInfo().activePanel;
                if (!activePanel && activePanel != "none") {
                    //show the panel and default to layers
                    $("#slide-panel-btn-overlays").click();
                }
                else if (activePanel != "none") {
                    $("#slide-panel-btn-" + activePanel).click();
                }
                else {
                    onCloseSlidePanel();
                }
            }
            else {
                //initialise to zero width, can't do this in the css as the map legends don't render
                $('#slide-content').css("width", "0px");
            }
        };
        this.addOverlays = function () {
            _this.overlays.addOverlays();
        };
        this.init();
    }
    return MapLayerSwitcher;
}());
exports.MapLayerSwitcher = MapLayerSwitcher;
//# sourceMappingURL=MapLayerSwitcher.js.map